import { defineMessages } from '../define';

export const admin = defineMessages(
  {
    'admin.members': 'Félagar',
    'admin.members_desc': 'Bjóða nýjum félögum, raddir, hlutverk og aðgangur',
    'admin.library': 'Lagasafn',
    'admin.library_desc': 'Lög, nótur, hljóðskrár, textar og lagalistar',
    'admin.stats': 'Mæting',
    'admin.stats_desc': 'Mætingartölfræði eftir félögum og röddum',
    'admin.errors': 'Villuskrá',
    'admin.errors_desc': 'Villur sem komu upp í kerfinu',
    'admin.layers': 'Lög frá fyrrverandi félögum',
    'admin.layers_desc': 'Flytja sameiginleg lög á nótum til annars félaga',

    // Member status
    'admin.status.invited': 'Boðið',
    'admin.status.active': 'Virkur',
    'admin.status.leave': 'Í leyfi',
    'admin.status.inactive': 'Óvirkur',
    'admin.status.erased': 'Eytt',
    'admin.role_desc.member': 'Sér efni fyrir sína rödd og allan kórinn',
    'admin.role_desc.editor': 'Lög, viðburðir og raddir (t.d. stjórnandi)',
    'admin.role_desc.admin': 'Allt, þar á meðal aðgangur og hlutverk',

    // Member list
    'admin.m.new': 'Nýr félagi',
    'admin.m.search': 'Leita að nafni, titli eða netfangi',
    'admin.m.filter_status': 'Staða',
    'admin.m.filter_section': 'Rödd',
    'admin.m.all': 'Allir',
    'admin.m.count': { one: '{count} félagi', other: '{count} félagar' },
    'admin.m.none_found': 'Enginn félagi passar við leitina',
    'admin.m.none_found_hint': 'Breyttu leitinni eða síunum.',
    'admin.m.editor_note': 'Sem ritstjóri geturðu breytt rödd, titli og mynd. Kerfisstjóri sér um aðgang og hlutverk.',

    // Form fields
    'admin.m.full_name': 'Fullt nafn',
    'admin.m.email': 'Netfang (til innskráningar)',
    'admin.m.section': 'Rödd',
    'admin.m.role': 'Hlutverk',
    'admin.m.title': 'Titill',
    'admin.m.title_hint': 'Valfrjálst, t.d. „Formaður“ eða „Raddformaður“.',
    'admin.m.status': 'Staða',
    'admin.m.conductor_editor': 'Stjórnandi fær hlutverkið Ritstjóri svo hann geti stýrt lögum og viðburðum.',
    'admin.m.name_required': 'Sláðu inn nafn.',
    'admin.m.email_invalid': 'Sláðu inn gilt netfang.',
    'admin.m.email_taken': 'Þetta netfang er þegar skráð á annan félaga.',
    'admin.m.own_role': 'Þú getur ekki breytt eigin hlutverki.',
    'admin.m.own_email': 'Annar kerfisstjóri þarf að breyta innskráningarnetfanginu þínu.',
    'admin.m.id_taken':
      'Félagi gæti þegar hafa verið stofnaður með fyrra netfanginu (sambandið rofnaði). Athugaðu listann áður en þú reynir aftur.',

    // Create
    'admin.m.create': 'Stofna félaga',
    'admin.m.created': '{name} var stofnaður',
    'admin.m.invite_next': 'Næsta skref: búðu til boðshlekk og sendu {name}.',
    'admin.m.later': 'Seinna',

    // Links
    'admin.m.make_invite': 'Búa til boðshlekk',
    'admin.m.new_invite': 'Nýr boðshlekkur',
    'admin.m.make_reset': 'Hlekkur til að endurstilla lykilorð',
    'admin.m.link_invite_title': 'Boðshlekkur',
    'admin.m.link_reset_title': 'Hlekkur til að endurstilla lykilorð',
    'admin.m.link_expires': 'Gildir til {date} og aðeins einu sinni.',
    'admin.m.link_hint': 'Sendu hlekkinn til félagans, t.d. í SMS eða tölvupósti. Eldri hlekkir af sömu gerð hætta að virka.',
    'admin.m.link_label': 'Hlekkur',
    'admin.m.share_invite_text': 'Boð í app Karlakórs Grafarvogs: {url}',
    'admin.m.share_reset_text': 'Hlekkur til að setja nýtt lykilorð í appi Karlakórs Grafarvogs: {url}',
    'admin.m.copy_failed': 'Ekki tókst að afrita. Haltu fingri á hlekknum til að afrita hann.',

    // Invite links by voice
    'admin.si.button': 'Boðshlekkur',
    'admin.si.title': 'Boðshlekkur eftir rödd',
    'admin.si.intro': 'Veldu rödd og titil ef við á. Sá sem fær hlekkinn skráir sjálfur nafn, netfang og síma og velur sér lykilorð.',
    'admin.si.title_label': 'Titill (valfrjálst)',
    'admin.si.title_hint': 'T.d. „Formaður“ eða „Raddformaður“. Má sleppa.',
    'admin.si.role_note': 'Nýi félaginn fær hlutverkið Félagi. Kerfisstjóri getur breytt því síðar.',
    'admin.si.create': 'Búa til hlekk',
    'admin.si.another': 'Annar hlekkur',
    'admin.si.link_title': 'Boðshlekkur: {section}',
    'admin.si.link_hint': 'Sendu hlekkinn til nýja félagans, t.d. í SMS eða tölvupósti. Hver hlekkur dugar fyrir einn félaga.',
    'admin.si.share_text': 'Boð í app Karlakórs Grafarvogs ({section}). Opnaðu hlekkinn og skráðu þig: {url}',
    'admin.si.pending': 'Ónotaðir hlekkir',
    'admin.si.pending_meta': 'Frá {name} · gildir til {date}',
    'admin.si.revoke': 'Afturkalla',
    'admin.si.revoke_label': 'Afturkalla hlekk: {section}',
    'admin.si.revoked': 'Hlekkurinn var afturkallaður',

    // Detail
    'admin.m.details': 'Upplýsingar',
    'admin.m.last_seen': 'Síðast í appinu',
    'admin.m.never': 'Aldrei',
    'admin.m.password': 'Aðgangur',
    'admin.m.password_set': 'Hefur sett lykilorð',
    'admin.m.password_not_set': 'Hefur ekki enn virkjað aðganginn',
    'admin.m.onboarding_pending': 'Á eftir að ljúka fyrstu skrefum',
    'admin.m.phone': 'Sími',
    'admin.m.contact_email': 'Netfang í félagatali',
    'admin.m.sharing': 'Sýnir í félagatali',
    'admin.m.shares_phone': 'símanúmer',
    'admin.m.shares_email': 'netfang',
    'admin.m.shares_nothing': 'Hvorki síma né netfang',
    'admin.m.saved': 'Breytingar vistaðar',
    'admin.m.requires_reset': 'Netfanginu var breytt. Félaginn þarf nýjan hlekk til að setja lykilorð fyrir nýja netfangið.',
    'admin.m.view_profile': 'Opna í félagatali',
    'admin.m.not_found': 'Félaginn fannst ekki',
    'admin.m.edit': 'Breyta félaga',
    'admin.m.photo': 'Mynd',

    // Actions
    'admin.m.actions': 'Aðgerðir',
    'admin.m.deactivate': 'Taka úr virkni',
    'admin.m.deactivate_confirm': 'Taka {name} úr virkni?',
    'admin.m.deactivate_body':
      'Aðgangi er lokað strax, félaginn er skráður út af öllum tækjum og hverfur úr félagatalinu. Hægt er að virkja hann aftur síðar.',
    'admin.m.deactivated': '{name} var tekinn úr virkni',
    'admin.m.reactivate': 'Virkja aftur',
    'admin.m.reactivated': '{name} var virkjaður aftur',
    'admin.m.revoke': 'Skrá út af öllum tækjum',
    'admin.m.revoke_confirm': 'Skrá {name} út af öllum tækjum?',
    'admin.m.revoke_body': 'Félaginn þarf að skrá sig aftur inn með lykilorði á hverju tæki.',
    'admin.m.revoked': '{name} var skráður út af öllum tækjum',
    'admin.m.erase': 'Eyða persónuupplýsingum',
    'admin.m.erase_confirm': 'Eyða persónuupplýsingum {name}?',
    'admin.m.erase_body':
      'Nafn, netfang, sími og mynd eru fjarlægð og einkamerkingum á nótur eytt. Skilaboð standa áfram undir „Fyrrverandi félagi“ og mæting nýtist aðeins í samanlagðri tölfræði. Þetta er ekki hægt að afturkalla.',
    'admin.m.erase_type': 'Skrifaðu {word} til að staðfesta',
    'admin.m.erase_word': 'EYÐA',
    'admin.m.erased': 'Persónuupplýsingum var eytt',
    'admin.m.erase_only_inactive': 'Aðeins er hægt að eyða persónuupplýsingum félaga sem hefur verið tekinn úr virkni.',
    'admin.m.export': 'Sækja gögn',
    'admin.m.export_hint': 'JSON-skrá með öllum gögnum félagans, t.d. vegna beiðni um aðgang að eigin gögnum.',
    'admin.m.exported': 'Skráin var sótt',

    // Errors admin
    'admin.e.count': { one: '{count} villa', other: '{count} villur' },
    'admin.e.empty': 'Engar villur skráðar',
    'admin.e.empty_hint': 'Villur sem koma upp í appinu eða á netþjóni birtast hér.',
    'admin.e.all': 'Allar',
    'admin.e.source.server': 'Netþjónn',
    'admin.e.source.client': 'App',
    'admin.e.route': 'Slóð',
    'admin.e.code': 'Kóði',
    'admin.e.message': 'Skilaboð',
    'admin.e.user': 'Notandi',
    'admin.e.ua': 'Vafri',
    'admin.e.no_message': '(engin skilaboð)',
    'admin.e.refresh': 'Uppfæra',
    'admin.e.housekeeping': 'Hreinsa gamalt',
    'admin.e.housekeeping_desc': 'Eyðir útrunnum innskráningum og hlekkjum, gömlum innskráningartakmörkunum og eyddum skrám.',
    'admin.e.housekeeping_done': 'Hreinsun lokið',
    'admin.e.housekeeping_nothing': 'Ekkert þurfti að hreinsa.',
    'admin.e.admin_only': 'Aðeins kerfisstjórar sjá villuskrána.',
    'admin.e.hk.sessions': 'Útrunnar innskráningar',
    'admin.e.hk.auth_tokens': 'Gamlir boðs- og endurstillingarhlekkir',
    'admin.e.hk.signup_invites': 'Gamlir boðshlekkir eftir rödd',
    'admin.e.hk.throttle': 'Gamlar innskráningartakmarkanir',
    'admin.e.hk.trash': 'Eyddar skrár fjarlægðar',
    'admin.e.hk.annotations': 'Gamlar eyddar glósur hreinsaðar',

    // Layers from former members ("Flytja lag")
    'admin.l.intro':
      'Þegar félagi hættir sjá aðrir áfram lögin sem hann deildi á nótum, merkt „(hætt/ur)“, en enginn getur breytt þeim. Flyttu slíkt lag til núverandi félaga sem tekur þá við því. Deilingin helst óbreytt.',
    'admin.l.admin_only': 'Aðeins kerfisstjórar geta flutt lög.',
    'admin.l.count': { one: '{count} lag', other: '{count} lög' },
    'admin.l.empty': 'Engin lög frá fyrrverandi félögum',
    'admin.l.empty_hint': 'Þegar félagi sem hafði deilt lögum á nótum hættir birtast lögin hér svo hægt sé að flytja þau til annars félaga.',
    'admin.l.refresh': 'Uppfæra',
    'admin.l.sheet_fallback': 'Nótur',
    'admin.l.audience': 'fyrir {list}',
    'admin.l.owner_left': '{name} (hætt/ur)',
    'admin.l.shared_with': 'Deilt með: {list}',
    'admin.l.someone': 'félagi',
    'admin.l.objects': { one: '{count} teikning', other: '{count} teikningar' },
    'admin.l.updated': 'síðast breytt {date}',
    'admin.l.transfer': 'Flytja til…',
    'admin.l.transfer_title': 'Flytja „{name}“',
    'admin.l.transfer_hint':
      'Veldu félagann sem tekur við laginu. Hann þarf að sjá þessar nótur – ritstjórar og kerfisstjórar sjá alltaf allar nótur.',
    'admin.l.offline': 'Það þarf nettengingu til að flytja lag.',
    'admin.l.search': 'Leita að nafni',
    'admin.l.people': 'Félagar',
    'admin.l.no_people': 'Enginn fannst',
    'admin.l.cant_see': 'Sér ekki þessar nótur',
    'admin.l.confirm_title': 'Flytja „{layer}“ til {name}?',
    'admin.l.confirm_body':
      '{name} verður eigandi lagsins og getur breytt því, deilt því og eytt því. Þau sem lagið er deilt með sjá það áfram.',
    'admin.l.confirm': 'Flytja',
    'admin.l.done': '„{layer}“ er nú í eigu {name}',
    'admin.l.recent': 'Flutt',
    'admin.l.now_owned': 'Nú í eigu {name}',
    'admin.l.err_changed': 'Lagið hefur þegar verið flutt eða því breytt. Listinn hefur verið uppfærður.',
    'admin.l.err_gone': 'Lagið fannst ekki lengur – því hefur verið eytt eða deilingu þess hætt.',
    'admin.l.err_cant_see': '{name} sér ekki þessar nótur. Veldu annan félaga.',
    'admin.l.err_unavailable': '{name} er ekki lengur virkur félagi. Veldu annan félaga.',
  },
  {
    'admin.members': 'Members',
    'admin.members_desc': 'Invite members, sections, roles and access',
    'admin.library': 'Library',
    'admin.library_desc': 'Songs, sheets, audio, lyrics and setlists',
    'admin.stats': 'Attendance',
    'admin.stats_desc': 'Attendance statistics by member and section',
    'admin.errors': 'Error log',
    'admin.errors_desc': 'Errors recorded by the system',
    'admin.layers': 'Layers from former members',
    'admin.layers_desc': 'Hand shared sheet layers over to another member',

    // Member status
    'admin.status.invited': 'Invited',
    'admin.status.active': 'Active',
    'admin.status.leave': 'On leave',
    'admin.status.inactive': 'Inactive',
    'admin.status.erased': 'Erased',
    'admin.role_desc.member': 'Sees material for their section and the whole choir',
    'admin.role_desc.editor': 'Songs, events and sections (e.g. the conductor)',
    'admin.role_desc.admin': 'Everything, including access and roles',

    // Member list
    'admin.m.new': 'New member',
    'admin.m.search': 'Search by name, title or e-mail',
    'admin.m.filter_status': 'Status',
    'admin.m.filter_section': 'Section',
    'admin.m.all': 'All',
    'admin.m.count': { one: '{count} member', other: '{count} members' },
    'admin.m.none_found': 'No member matches the search',
    'admin.m.none_found_hint': 'Change the search or the filters.',
    'admin.m.editor_note': 'As an editor you can change section, title and photo. An administrator manages access and roles.',

    // Form fields
    'admin.m.full_name': 'Full name',
    'admin.m.email': 'E-mail (for sign-in)',
    'admin.m.section': 'Section',
    'admin.m.role': 'Role',
    'admin.m.title': 'Title',
    'admin.m.title_hint': 'Optional, e.g. “Chair” or “Section leader”.',
    'admin.m.status': 'Status',
    'admin.m.conductor_editor': 'The conductor gets the Editor role so they can manage songs and events.',
    'admin.m.name_required': 'Please enter a name.',
    'admin.m.email_invalid': 'Please enter a valid e-mail address.',
    'admin.m.email_taken': 'This e-mail is already registered to another member.',
    'admin.m.own_role': 'You cannot change your own role.',
    'admin.m.own_email': 'Another administrator must change your sign-in e-mail.',
    'admin.m.id_taken':
      'A member may already have been created with the previous e-mail (the connection dropped). Check the list before trying again.',

    // Create
    'admin.m.create': 'Create member',
    'admin.m.created': '{name} was created',
    'admin.m.invite_next': 'Next step: create an invite link and send it to {name}.',
    'admin.m.later': 'Later',

    // Links
    'admin.m.make_invite': 'Create invite link',
    'admin.m.new_invite': 'New invite link',
    'admin.m.make_reset': 'Password reset link',
    'admin.m.link_invite_title': 'Invite link',
    'admin.m.link_reset_title': 'Password reset link',
    'admin.m.link_expires': 'Valid until {date}, and only once.',
    'admin.m.link_hint': 'Send the link to the member, e.g. by text message or e-mail. Older links of the same kind stop working.',
    'admin.m.link_label': 'Link',
    'admin.m.share_invite_text': 'Invitation to the Karlakór Grafarvogs app: {url}',
    'admin.m.share_reset_text': 'Link to set a new password in the Karlakór Grafarvogs app: {url}',
    'admin.m.copy_failed': 'Could not copy. Press and hold the link to copy it.',

    // Invite links by voice
    'admin.si.button': 'Invite link',
    'admin.si.title': 'Invite link by section',
    'admin.si.intro': 'Choose the section and, if needed, a title. Whoever gets the link enters their own name, e-mail and phone and chooses a password.',
    'admin.si.title_label': 'Title (optional)',
    'admin.si.title_hint': 'E.g. “Chair” or “Section leader”. Can be left empty.',
    'admin.si.role_note': 'The new member gets the Member role. An administrator can change it later.',
    'admin.si.create': 'Create link',
    'admin.si.another': 'Another link',
    'admin.si.link_title': 'Invite link: {section}',
    'admin.si.link_hint': 'Send the link to the new member, e.g. by text message or e-mail. Each link is for one member.',
    'admin.si.share_text': 'Invitation to the Karlakór Grafarvogs app ({section}). Open the link and sign up: {url}',
    'admin.si.pending': 'Unused links',
    'admin.si.pending_meta': 'From {name} · valid until {date}',
    'admin.si.revoke': 'Revoke',
    'admin.si.revoke_label': 'Revoke link: {section}',
    'admin.si.revoked': 'The link was revoked',

    // Detail
    'admin.m.details': 'Details',
    'admin.m.last_seen': 'Last seen in the app',
    'admin.m.never': 'Never',
    'admin.m.password': 'Access',
    'admin.m.password_set': 'Has set a password',
    'admin.m.password_not_set': 'Has not activated the account yet',
    'admin.m.onboarding_pending': 'Has not finished the first steps',
    'admin.m.phone': 'Phone',
    'admin.m.contact_email': 'Directory e-mail',
    'admin.m.sharing': 'Shows in the directory',
    'admin.m.shares_phone': 'phone number',
    'admin.m.shares_email': 'e-mail',
    'admin.m.shares_nothing': 'Neither phone nor e-mail',
    'admin.m.saved': 'Changes saved',
    'admin.m.requires_reset': 'The e-mail was changed. The member needs a new link to set a password for the new e-mail.',
    'admin.m.view_profile': 'Open in directory',
    'admin.m.not_found': 'Member not found',
    'admin.m.edit': 'Edit member',
    'admin.m.photo': 'Photo',

    // Actions
    'admin.m.actions': 'Actions',
    'admin.m.deactivate': 'Deactivate',
    'admin.m.deactivate_confirm': 'Deactivate {name}?',
    'admin.m.deactivate_body':
      'Access is closed immediately, the member is signed out on all devices and disappears from the directory. They can be reactivated later.',
    'admin.m.deactivated': '{name} was deactivated',
    'admin.m.reactivate': 'Reactivate',
    'admin.m.reactivated': '{name} was reactivated',
    'admin.m.revoke': 'Sign out on all devices',
    'admin.m.revoke_confirm': 'Sign {name} out on all devices?',
    'admin.m.revoke_body': 'The member will have to sign in again with their password on every device.',
    'admin.m.revoked': '{name} was signed out on all devices',
    'admin.m.erase': 'Erase personal data',
    'admin.m.erase_confirm': 'Erase the personal data of {name}?',
    'admin.m.erase_body':
      'Name, e-mail, phone and photo are removed and private annotations deleted. Messages remain under “Former member” and attendance is only used in aggregate statistics. This cannot be undone.',
    'admin.m.erase_type': 'Type {word} to confirm',
    'admin.m.erase_word': 'ERASE',
    'admin.m.erased': 'Personal data was erased',
    'admin.m.erase_only_inactive': 'Personal data can only be erased for a member who has been deactivated.',
    'admin.m.export': 'Download data',
    'admin.m.export_hint': 'A JSON file with all of the member’s data, e.g. for a data access request.',
    'admin.m.exported': 'The file was downloaded',

    // Errors admin
    'admin.e.count': { one: '{count} error', other: '{count} errors' },
    'admin.e.empty': 'No errors recorded',
    'admin.e.empty_hint': 'Errors in the app or on the server appear here.',
    'admin.e.all': 'All',
    'admin.e.source.server': 'Server',
    'admin.e.source.client': 'App',
    'admin.e.route': 'Route',
    'admin.e.code': 'Code',
    'admin.e.message': 'Message',
    'admin.e.user': 'User',
    'admin.e.ua': 'Browser',
    'admin.e.no_message': '(no message)',
    'admin.e.refresh': 'Refresh',
    'admin.e.housekeeping': 'Clean up old data',
    'admin.e.housekeeping_desc': 'Removes expired sessions and links, old sign-in throttles and deleted files.',
    'admin.e.housekeeping_done': 'Clean-up finished',
    'admin.e.housekeeping_nothing': 'Nothing needed cleaning.',
    'admin.e.admin_only': 'Only administrators can see the error log.',
    'admin.e.hk.sessions': 'Expired sessions',
    'admin.e.hk.auth_tokens': 'Old invite and reset links',
    'admin.e.hk.signup_invites': 'Old invite links by voice',
    'admin.e.hk.throttle': 'Old sign-in throttles',
    'admin.e.hk.trash': 'Deleted files removed',
    'admin.e.hk.annotations': 'Old deleted annotations purged',

    // Layers from former members
    'admin.l.intro':
      'When a member leaves, the layers they shared on sheets stay visible to the people they shared them with, marked “(left)”, but nobody can change them. Hand such a layer over to a current member, who then takes it over. The sharing stays the same.',
    'admin.l.admin_only': 'Only administrators can transfer layers.',
    'admin.l.count': { one: '{count} layer', other: '{count} layers' },
    'admin.l.empty': 'No layers from former members',
    'admin.l.empty_hint': 'When a member who had shared layers on sheets leaves, the layers appear here so they can be handed over to another member.',
    'admin.l.refresh': 'Refresh',
    'admin.l.sheet_fallback': 'Sheet',
    'admin.l.audience': 'for {list}',
    'admin.l.owner_left': '{name} (left)',
    'admin.l.shared_with': 'Shared with: {list}',
    'admin.l.someone': 'a member',
    'admin.l.objects': { one: '{count} drawing', other: '{count} drawings' },
    'admin.l.updated': 'last changed {date}',
    'admin.l.transfer': 'Transfer to…',
    'admin.l.transfer_title': 'Transfer “{name}”',
    'admin.l.transfer_hint': 'Choose the member who takes over the layer. They must be able to see this sheet – editors and administrators always can.',
    'admin.l.offline': 'Transferring a layer needs an internet connection.',
    'admin.l.search': 'Search by name',
    'admin.l.people': 'Members',
    'admin.l.no_people': 'Nobody found',
    'admin.l.cant_see': "Can't see this sheet",
    'admin.l.confirm_title': 'Transfer “{layer}” to {name}?',
    'admin.l.confirm_body': '{name} becomes the owner of the layer and can change, share and delete it. The people it is shared with keep seeing it.',
    'admin.l.confirm': 'Transfer',
    'admin.l.done': '“{layer}” now belongs to {name}',
    'admin.l.recent': 'Transferred',
    'admin.l.now_owned': 'Now owned by {name}',
    'admin.l.err_changed': 'The layer has already been transferred or changed. The list has been refreshed.',
    'admin.l.err_gone': 'The layer no longer exists – it was deleted or is no longer shared.',
    'admin.l.err_cant_see': "{name} can't see this sheet. Choose another member.",
    'admin.l.err_unavailable': '{name} is no longer an active member. Choose another member.',
  },
);
